import type { U3204QuotaAxis, U3204QuotaStatus } from '../U3204Service';

export function u3204IsQuotaFooterVisible(status: U3204QuotaStatus | null): boolean {
  if (!status) return false;
  return status.user.quotaMonthlyTokens != null || status.group.quotaMonthlyTokens != null;
}

export function u3204ResolveQuotaBarPercent(axis: U3204QuotaAxis): number {
  if (axis.usagePercent != null) {
    return Math.min(100, Math.max(0, axis.usagePercent));
  }
  if (axis.quotaMonthlyTokens == null || axis.quotaMonthlyTokens <= 0) {
    return 0;
  }
  return Math.min(100, Math.max(0, (axis.usageTokens / axis.quotaMonthlyTokens) * 100));
}

export function u3204ResolveQuotaBarColor(percent: number): string {
  if (percent >= 100) return 'bg-red-500';
  if (percent >= 80) return 'bg-amber-500';
  return 'bg-primary-600';
}

export function u3204ResolveGroupQuotaBarColor(percent: number): string {
  if (percent >= 100) return 'bg-red-500';
  if (percent >= 80) return 'bg-amber-500';
  return 'bg-neutral-400';
}

export function u3204ResolvePercentTextClass(percent: number): string {
  if (percent >= 100) return 'font-medium text-red-600';
  if (percent >= 80) return 'font-medium text-amber-600';
  return 'text-muted-foreground';
}
